<div class="info-div row mapfre {{additionalClasses}} ie-block">
  <div class="icon-container" *ngIf="type === 'icon'">
      <div class="align-middle {{additionDivClass}}">
        <mapfre-icon
          iconClasses="{{iconClasses}}"
        ></mapfre-icon>
      </div>
    </div>
    <div class="information-container" [ngClass]="{ 'with-icon': type === 'icon', 'full-width': type !== 'icon'  } ">
      <ng-content></ng-content>
    </div>
  </div>
